module.exports = __webpack_public_path__ + "media/assets/images/chrome-settings-6352050a8775caebc0fb64eff0447ce4.svg";